import { createReducer } from 'redux-starter-kit';
import { SET_ADVISOR } from './actions';

interface Advisor {
  advisor: any;
}

const INITIAL_STATE: Advisor = {
  advisor: {}
};

export default createReducer(INITIAL_STATE, {
  [SET_ADVISOR]: (state, action) => {
    state.advisor = action.payload;
  }
});
